import Cookies from 'js-cookie'
import * as types from '../mutation-types'

import is from '../../web/plugins/helper/is'
import { checkVariable, getBoolValue } from '../../plugins/helper'

const transformResult = () => {
  const store = Cookies.get('fa_auth')
  if (checkVariable(store)) {
    const result = JSON.parse(store.trim())

    return getBoolValue(result.success)
  }

  return false
}

// state
export const state = {
  faAuthCheck: transformResult(),
}

// mutations
export const mutations = {
  [types.SAVE_2_STEP_TOKEN](state, payload) {
    const { success, remember } = payload
    state.faAuthCheck = success
    const domain = is.getValueSetting('appDomain')
    let options = { expires: (remember ? 365 : 1) }
    if (checkVariable(domain)) {
      options = { ...options, domain }
    }
    Cookies.set('fa_auth', JSON.stringify(payload), options)
  },
}

// actions
export const actions = {
  save2StepAuth({ commit }, payload) {
    commit(types.SAVE_2_STEP_TOKEN, payload)
  },
}

// getters
export const getters = {
  faAuthCheck: state => state.faAuthCheck,
}
